// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3tKwF","label":"Labeled_label__1sA_b","divider":"Labeled_divider__klxyH"};